import { getData } from '@/utils/fetch';
import { getCookie } from '@/utils/cookie';
import { getOrgId } from '@/utils/tool';

/**
 * LiveDesk 子站鉴权接口
 */
export const liveDeskAuth = () => {
  const jwt = getCookie('Etoken');
  return getData<any>(
    `/api/livedesk/public/api/v1/sso/validate`,
    { jwt, orgid: getOrgId() },
    false,
  );
};

/**
 * 获取LiveDesk项目列表
 */
export const getLiveDeskProjectList = () => {
  return getData<any>(`/api/livedesk/api/v1/organizations/accounts`, undefined, undefined, {
    orgid: getOrgId(),
  });
};
